import type { Client, RequestContext } from "../client";
import type { InvitationResource } from "../resources";
import { MixedScopeBaseRepository } from "./mixedScopeBaseRepository";
export class InvitationRepository extends MixedScopeBaseRepository<InvitationResource, InvitationResource> {
    constructor(client: Client, requestContext: RequestContext) {
        super("Invitations", client, requestContext);
    }
    invite(teamIds: string[], spaceId: string | null): Promise<InvitationResource> {
        return this.client.post(this.requestContext, this.client.getLink("Invitations"), { AddToTeamIds: teamIds, SpaceId: spaceId });
    }
}
